import React, { useEffect, useState } from "react";
import ButtonGeneric from "../../../components/Buttons/ButtonGeneric";
import { useForm } from "../../../Hooks/UseForm";
import "../../css/steps.css";
import { amountPayment } from "../../../propsType/Payemnts";
import {
  validateAmount,
  validateAmountToPay,
} from "../../../validations/formValidations";
import { NumberFormatBase } from "react-number-format";
import Modal from "../../../components/Modals/Modal";
import { colors } from "../../../propsType/Colors";


//Funcion que retorna un Componente tipo input para ingresar el monto a pagar 
//Componete que validad el formarto de los decimales 
let montoPago = 0;
function CardExpiry({ errors, setState, monto, deafult }) {
  const rightToLeftFormatter = (value) => {

    if (!Number(value)) { montoPago = 0; return "" }
    let amount = "";
    if (amount.length > 2) {

      amount = parseInt(value).toFixed(2);
    } else {
      amount = (parseInt(value) / 100).toFixed(2);
    }

    montoPago = amount;
      return `${amount}`;
  };


  useEffect(() => {

    setState(Math.abs(monto))

  }, [])

  return (
    <NumberFormatBase
      format={rightToLeftFormatter}
      value={monto > 0 ? monto : ""}
      onValueChange={(values) => { setState(values.formattedValue); }}
      name={"amount"}
      className={`focus:ring-indigo-500 text-center p-5 focus:border-indigo-500 block w-full pl-7 pr-12 text-4xl border-[1px] ${errors ? "border-red-500 " : "border-gray-400 "
        } rounded-md`}
    />
  );
}


function Step2({
  stapsState,
  setStapsState,
  deatils,
  stespData,
  setStespData,
}) {
  const { form, errors, handleChange, handleSubmit, handleBlur } = useForm(
    amountPayment,
    validateAmount,
    stespData
  );
  const [currency, setCurrency] = useState("");
  const [errorCurrency, setErrorCurrency] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [msgModal, setMsgModal] = useState("");
  const [monto, setMonto] = useState('')
  const validateCurrency = () => {
    let newCurrency =
      stespData.data.title === "Bolívares" ? deatils.deudaTotalVEF : deatils.deudaTotalUSD;
    newCurrency = newCurrency.replace(/,/g, ".");

    let isValid = true;
    if (stespData.data.title === "Bolívares") {
      const { msg, valid } = validateAmountToPay(newCurrency, currency, 1);
      setShowModal(!valid);
      setMsgModal(msg);
      isValid = valid;
    }
    if (stespData.data.title === "Dólares") {
      const { msg, valid } = validateAmountToPay(newCurrency, currency, 2);
      setShowModal(!valid);
      setMsgModal(msg);
      isValid = valid;
    }
    return isValid;
  };

  const siguiente = () => {

    if (montoPago === 0) { setShowModal(true); setMsgModal("Por favor ingresa un monto."); }
    else {
      montoPago = 0;
      localStorage.setItem('nrm', deatils.nroCuenta)
      setStespData
        ({
          ...stespData,
          metodoAPagar: currency,
        });
      setStapsState
        ({
          ...stapsState,
          option1: false,
          option2: false,
          option3: true,
          option4: false,
          option5: false,
        });
    }
  };

  const valModalPayment = () => {
    montoPago = 0;
    setShowModal(false);
  };

  const atras = () => {
    setStespData({ ...stespData, back: true });
    setStapsState({
      ...stapsState,
      option1: true,
      option2: false,
      option3: false,
      option4: false,
      option5: false,
    });
  };

  useEffect(() => {
    if (currency) {
      setErrorCurrency(false);
    }
  }, [currency]);

  return (
    <div className="w-full flex-col flex gap-5">
      <div className="bg-white w-full px-4 py-5 border-b border-gray-200 sm:px-6">
        <div className="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
          <div className="ml-4 mt-4">
            <h3 className="text-2xl leading-6 font-medium text-gray-900">
              Monto
            </h3>
            {stespData?.data?.title === "Bolívares" ? (
              <>
                <p className="mt-1 text-sm text-gray-500">
                  Coloca el monto a pagar, haz clic en siguiente para continuar
                </p>
              </>
            ) : (
              <>
                <p className="mt-1 text-sm text-gray-500">
                  Coloca el monto a pagar, haz clic en siguiente para continuar
                </p>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="flex justify-center items-center flex-col gap-6 ">
        <div className="wrapper antialiased text-gray-900">
          <div className=" relative  text-center">
            {deatils?.deudaTotalVEF === "0" || deatils?.deudaTotalUSD === "0" ? (
              <>
                <span className="block mb-3 text-xl text-center font-medium text-gray-700">
                  Tu saldo de facturación esta al día{" "}
                </span>
              </>
            ) : (
              <>
                <span>
                  {deatils?.deudaTotalVEF < "0" || deatils?.deudaTotalUSD < "0" ? (
                    <>
                      <span className="block mb-3 text-3xl text-center font-medium text-gray-700">
                        {" "}
                        Tu Saldo a Favor es{" "}
                      </span>
                    </>
                  ) : (
                    <>
                      <span className="block mb-3 text-xl text-center font-medium text-gray-700">
                        {" "}
                        Tu Saldo es{" "}
                      </span>
                    </>
                  )}
                </span>
              </>
            )}
            <div className=" rounded-[30px]  relative  flex justify-center items-center ">
              <div className="text-[3rem] top-[10%] text-[#606060] font-medium w-[75%] h-[75%]  flex justify-center items-center rounded-full borde border-gray-400 ">
                {stespData?.data?.title === "Bolívares" && (
                  <>
                    <span>Bs {Math.abs(deatils?.deudaTotalVEF).toFixed(2)}</span>
                  </>
                )}
                {stespData?.data?.title === "Dólares" && (
                  <>
                    <span>USD {Math.abs(deatils?.deudaTotalUSD).toFixed(2)}</span>
                  </>
                )}
              </div>
            </div>
            <div className="relative px-4  ">
              <div className="p-6 ">
                <div>
                  <label
                    htmlFor="price"
                    className="block mb-3 text-xl text-center font-medium text-gray-700"
                  >
                    Monto a Pagar

                  </label>
                  {deatils?.deudaTotalVEF > "0" || deatils?.deudaTotalUSD > "0" ? (
                    <label
                      htmlFor="price"
                      className="block mb-3 text-l text-center font-medium text-red-400"
                    >
                      El monto a pagar debe ser mayor o igual a tu deuda

                    </label>) : (
                    <>
                    </>
                  )}

                  {stespData?.data?.title === "Dólares" && (
                    <p className={`text-sm text-[${colors.lightBlue}]`}>

                      Este saldo incluye el 3% del IGTF
                    </p>
                  )}

                  <div className=" relative mt-4 rounded-md shadow-sm">
                    <CardExpiry setState={setCurrency} errors={errorCurrency} monto=
                      {stespData?.data?.title === "Bolívares" ? deatils?.deudaTotalVEF : deatils?.deudaTotalUSD} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        active={showModal}
        setActive={setShowModal}
        string={"error"}
        message={msgModal}
      >
        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
          <button
            type="button"
            onClick={valModalPayment}
            className="inline-flex w-full justify-center rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
          >
            Volver
          </button>
        </div>
      </Modal>
      <div className="w-full flex justify-between  gap-[50%] p-5 ">
        <div className="w-full">
          <ButtonGeneric funtion={atras} text={"Volver"} />
        </div>
        <div className="w-full">
          <ButtonGeneric funtion={siguiente} text={"Siguiente"} />
        </div>
      </div>
    </div>
  );
}

export default Step2;
